<script setup lang="ts">
import type { DataItem as JobHistoryTableDataItem } from '@/components/tables/JobHistoryTable.vue';

import { computed } from 'vue';

import JobHistoryTable from '@/components/tables/JobHistoryTable.vue';
import PageContentWrapper from '@/components/wrappers/PageContentWrapper.vue';
import TablePageShadowWrapper from '@/components/wrappers/TablePageShadowWrapper.vue';
import useCommonRouteQuery from '@/composables/routeQueries/useCommonRouteQuery';
import useJobHistoryPageView from '@/composables/views/useJobHistoryPageView';
import * as jobHistoryTableHelpers from '@/helpers/tables/jobHistory';

const { queryJobId, queryJobDate } = useCommonRouteQuery({});

const { isFetchingViewData, viewData } = useJobHistoryPageView(
  queryJobId,
  queryJobDate,
);

const jobHistoryLogs = computed(() => viewData.value?.jobHistoryLogs);

const jobHistoryTableData = computed(() => {
  const _jobHistoryTableData: JobHistoryTableDataItem[] = [];
  if (!jobHistoryLogs.value?.length) return _jobHistoryTableData;
  jobHistoryLogs.value.forEach(function (jobHistoryLog, jobHistoryLogIndex) {
    _jobHistoryTableData.push(
      jobHistoryTableHelpers.getTableItem(jobHistoryLog, jobHistoryLogIndex),
    );
  });
  return _jobHistoryTableData;
});
</script>

<template>
  <div :class="$style.jobHistoryPageView" data-testid="jobHistoryPageView">
    <PageContentWrapper>
      <h2 class="g-h2">Shows all job actions</h2>
      <TablePageShadowWrapper :class="$style.tablePageShadowWrapper">
        <JobHistoryTable
          :data="jobHistoryTableData"
          :loading="isFetchingViewData"
        />
      </TablePageShadowWrapper>
    </PageContentWrapper>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.jobHistoryPageView {
}
  .tablePageShadowWrapper {
    max-width: variables.$tableWrapperWidth;
  }
</style>
